
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel, SectionOptionDto } from "@insite/client-framework/Types/ApiModels";


export const XngPopulateApiParameter: any = (props: any) => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    props.apiParameter = {
        cartLines: order.value.orderLines!.map(
            (line: OrderLineModel) =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                    sectionOptions: line.sectionOptions?.map(
                        (sectionOption: SectionOptionDto) => 
                        ({
                            sectionOptionId: sectionOption.sectionOptionId
                        })
                    )
                } as CartLineModel),
        ),
    } as CartLineCollectionModel;
};

replaceInChain(chain, PopulateApiParameter, XngPopulateApiParameter);
